import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LayersIcon, XIcon } from 'lucide-react';
import { useContentNotes } from '../contexts/ContentNotesContext';
import type { ContentNoteEntry } from '../types/landing';
import { noteStyles } from './ContentNote';
interface NotesLegendProps {
  notes: ContentNoteEntry[];
  title: string;
  subtitle: string;
}
export function NotesLegend({
  notes,
  title,
  subtitle
}: NotesLegendProps) {
  const on = useContentNotes();
  const [open, setOpen] = useState(false);
  if (!on) return null;
  return <div className="fixed bottom-20 left-4 z-50 md:bottom-4" data-id="element-133" data-mp="k45f5qkpsva2">
      <AnimatePresence data-id="element-134" data-mp="k4dr9g90jwk7">
        {open && <motion.div initial={{
        opacity: 0,
        y: 8,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.97
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-2 max-h-[70vh] w-[calc(100vw-2rem)] max-w-sm origin-bottom-left overflow-y-auto rounded-md border border-brand-line bg-white p-4 shadow-xl" role="dialog" aria-label={title} data-id="element-135" data-mp="f5andz4rrwdt">
            <div className="flex items-start justify-between" data-id="element-136" data-mp="2k6k6a2u7xfmw">
              <div data-id="element-137" data-mp="2k8dc5fx0bvtu">
                <p className="text-sm font-bold text-brand-navy" data-id="element-138" data-mp="2k8ww1267wuai">{title}</p>
                <p className="text-xs text-brand-muted" data-id="element-139" data-mp="2p5vo7f6bmr62">{subtitle}</p>
              </div>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close notes" className="p-1 text-brand-muted hover:text-brand-ink" data-id="element-140" data-mp="3cvpzvtewm9oq">
                <XIcon className="h-4 w-4" data-id="element-141" data-mp="335o9uw2zqh76" />
              </button>
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-142" data-mp="333k6cf907k7f">
              {(['wp', 'dynamic', 'hybrid'] as const).map(k => <span key={k} className={`rounded-sm border px-1.5 py-0.5 text-[10px] font-semibold uppercase ${noteStyles[k].cls}`} data-id="element-143" data-mp="3vtk31qtcpqz7">{noteStyles[k].label}</span>)}
            </div>
            <ol className="mt-3 divide-y divide-brand-line" data-id="element-144" data-mp="ebwp1ufoa2br">
              {notes.map(n => <li key={n.section} className="py-2" data-id="element-145" data-mp="9cjtmlaqjmxk">
                  <div className="flex items-center justify-between gap-2" data-id="element-146" data-mp="9d381s16ft6u">
                    <span className="text-xs font-semibold text-brand-ink" data-id="element-147" data-mp="59dnddnmhvr3">{n.section}</span>
                    <span className={`shrink-0 rounded-sm border px-1.5 py-0.5 text-[10px] font-semibold uppercase ${noteStyles[n.kind].cls}`} data-id="element-148" data-mp="akbfpnzict1">{noteStyles[n.kind].label}</span>
                  </div>
                  <p className="mt-0.5 text-xs text-brand-muted" data-id="element-149" data-mp="3mq592e44pksb">{n.detail}</p>
                </li>)}
            </ol>
          </motion.div>}
      </AnimatePresence>
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex items-center gap-2 rounded-full bg-brand-ink px-4 py-2.5 text-xs font-semibold text-white shadow-lg transition-colors duration-150 hover:bg-black" data-id="element-150" data-mp="3drb6m744a06u">
        <LayersIcon className="h-4 w-4" aria-hidden="true" data-id="element-151" data-mp="1jat8g17w825s" />
        Template notes
      </button>
    </div>;
}